import { RankRequirement } from './types';

export const RANKS: RankRequirement[] = [
  { id: 'COMM', name: 'Community', shortName: 'Comm', order: 0 },
  { id: 'CRMN', name: 'Crewman', shortName: 'Crew', order: 10 },
  { id: 'PO3', name: 'Petty Officer 3rd Class', shortName: 'PO3', minEvents: 1, order: 20 },
  { id: 'PO2', name: 'Petty Officer 2nd Class', shortName: 'PO2', minMonths: 3, minEvents: 1, order: 30 },
  { id: 'PO1', name: 'Petty Officer 1st Class', shortName: 'PO1', minMonths: 4, minEvents: 1, minPoints: 15, order: 40 },
  { id: 'CPO', name: 'Chief Petty Officer', shortName: 'CPO', minMonths: 5, minEvents: 2, minPoints: 15, order: 50 },
  { id: 'SCPO', name: 'Senior Chief Petty Officer', shortName: 'SCPO', minMonths: 5, minEvents: 4, minPoints: 60, order: 60 },
  { id: 'MCPO', name: 'Master Chief Petty Officer', shortName: 'MCPO', minMonths: 5, minEvents: 4, minPoints: 70, order: 70 },
  { id: 'ENS', name: 'Ensign', shortName: 'ENS', minMonths: 6, otsRequired: true, order: 80 },
  { id: 'LTJG', name: 'Lieutenant Junior Grade', shortName: 'LTJG', previousRankId: 'ENS', previousRankMonths: 6, minPoints: 170, order: 90 }, // OR OTS + OCC handled in logic
  { id: 'LT', name: 'Lieutenant', shortName: 'LT', previousRankId: 'LTJG', previousRankMonths: 9, minPoints: 290, otsRequired: true, occRequired: true, order: 100 },
  { id: 'LCDR', name: 'Lieutenant Commander', shortName: 'LCDR', previousRankId: 'LT', previousRankMonths: 12, minPoints: 430, otsRequired: true, occRequired: true, order: 110 },
  { id: 'CMDR', name: 'Commander', shortName: 'CMDR', previousRankId: 'LCDR', previousRankMonths: 12, minPoints: 590, otsRequired: true, occRequired: true, order: 120 },
];

export const EVENT_TYPES = ['Muster', 'Convention', 'Volunteer', 'Meeting', 'Away Mission', 'Monthly Report', 'Department Report', 'Shift', 'Other'];

export const DEPARTMENTS = [
  'Command',
  'Operations',
  'Engineering',
  'Sciences',
  'Medical',
  'Security',
  'Navigation/Helm',
  'Tactical',
  'Communications',
  'Other'
];

export const ROLES = [
  { id: 'admin', name: 'Administrator', description: 'Full system command access (Edit users, roles, ranks, departments, events)' },
  { id: 'user_manager', name: 'User Manager', description: 'Manage personnel files and roles (Cannot edit system config like ranks)' },
  { id: 'dept_lead', name: 'Department Lead', description: 'Submit department reports and manage events (No Command Deck access)' },
  { id: 'member', name: 'Crew Member', description: 'Standard access (View missions, conventions, personal stats)' },
  { id: 'inventory', name: 'Quartermaster', description: 'Manage physical props and inventory in Convention Planner' },
  { id: 'user', name: 'Con Duty Roster Admin', description: 'Initialize and manage new conventions' },
  { id: 'read_only', name: 'Pending / Read Only', description: 'New registration awaiting access approval' },
  { id: 'guest', name: 'Guest / Volunteer', description: 'Limited access (Only view/sign up for convention shifts)' },
];

export const PERMISSIONS = {
  MANAGE_USERS: 'manage_users',
  MANAGE_EVENTS: 'manage_events',
  MANAGE_PROMOTIONS: 'manage_promotions',
  VIEW_ALL: 'view_all',
  GUEST_VIEW: 'guest_view',
};

export const ROLE_PERMISSIONS: Record<string, string[]> = {
  admin: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.MANAGE_EVENTS, PERMISSIONS.MANAGE_PROMOTIONS, PERMISSIONS.VIEW_ALL],
  user_manager: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_ALL],
  dept_lead: [PERMISSIONS.MANAGE_EVENTS, PERMISSIONS.VIEW_ALL],
  member: [PERMISSIONS.VIEW_ALL],
  read_only: [PERMISSIONS.VIEW_ALL],
  guest: [PERMISSIONS.GUEST_VIEW],
};
